import { makeStyles } from '@material-ui/styles'
import type React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import useReactRouter from 'use-react-router'
import {
  activateUserUrl,
  type CustomerTiers,
  forgotPasswordUrl,
  loginUrl,
  loginWithCredentialsUrl,
  resetPasswordUrl,
  setCookieUrl,
} from 'app/constants'
import Progress from 'core/components/progress/Progress'
import { setupSession } from 'core/containers/AppController'
import ActivateUserPage from 'core/public/ActivateUserPage'
import ForgotPasswordPage from 'core/public/ForgotPasswordPage'
import LoginPage from 'core/public/LoginPage'
import ResetPasswordPage from 'core/public/ResetPasswordPage'
import SetCookiePage from 'core/public/SetCookiePage'

const useStyles = makeStyles(() => ({
  progress: {
    '& img': {
      height: 130,
    },
  },
}))

interface PublicContainerProps {
  loginFeatures: {
    customerTier: CustomerTiers
    ssoEnabled: boolean
  }
  infraHostUrl?: string
}

const PublicContainer: React.FC<PublicContainerProps> = ({ loginFeatures, infraHostUrl }) => {
  const classes = useStyles()
  const { location } = useReactRouter()

  return (
    <Switch>
      <Route path={setCookieUrl} component={SetCookiePage} />
      <Route path={resetPasswordUrl} component={ResetPasswordPage} />
      <Route path={forgotPasswordUrl} component={ForgotPasswordPage} />
      <Route path={activateUserUrl} component={ActivateUserPage} />
      <Route path={[loginWithCredentialsUrl, loginUrl]}>
        {loginFeatures ? (
          <LoginPage
            onAuthSuccess={setupSession}
            ssoEnabled={loginFeatures.ssoEnabled}
            customerTier={loginFeatures.customerTier}
            infraHostUrl={infraHostUrl}
          />
        ) : (
          <div className={classes.progress}>
            <Progress loading message="Loading..." />
          </div>
        )}
      </Route>
      <Route>
        <Redirect
          to={{
            pathname: loginUrl,
            state: { from: location.pathname + location.search },
          }}
        />
      </Route>
    </Switch>
  )
}

export default PublicContainer
